import {BaseModel} from 'paliari-js-utils'

const attrs = () => ({
  id: null,
  descricao: '',
  nfe_id: null,
  nfe_situacao_tomador_id: null
})

export default class NfeRecepcao extends BaseModel {
  constructor(obj) {
    super(attrs(), obj)
  }
}
